// extracted by css-extract-rspack-plugin
export default {"cls1":"ChurnedUserReactivationButton-cls1_G9P","cls2":"ChurnedUserReactivationButton-cls2_M8d ChurnedUserReactivationButton-cls1_G9P"};